import React from "react";
import { Breadcrumb, Row } from "antd";
import { Link } from "react-router-dom";
import { gaEvent } from "analytics/analytics";
import * as GA from "../../../constants/analytics";
export default function BreadCrumbComponent({ page }) {
  return (
    <div>
      <Row style={{ marginBottom: "1.5rem" }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/"
              onClick={() => {
                gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_HOME);
              }}
            > Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/master-catalogue"
              onClick={() => {
                gaEvent(GA.EVENT.CLICK, GA.CATEGORY.RETURN, GA.DESCRIPTION.RETURN_TO_MASTER_CATALOGUE);
              }}
            > All Products</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            {page ? page === "edit" ? "Edit Product" : "Add Product" : "Add Product"}
            {/* {page ? "Edit Product" : "Add Product"} */}
          </Breadcrumb.Item>
        </Breadcrumb>
      </Row>
    </div>
  );
}
